import { SiteItem, documentLibraryItem } from "../../redux/models/reduxModels";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { logger } from "../../../../utilities/logger";

export class FolderView {
    constructor(private siteInfo: SiteItem[], private currentDirectory: IPageSettings) { }

    canViewFolder(): boolean {
        if (this.siteInfo && this.siteInfo.length > 0) {
            try {
                const sites: SiteItem[] = this.siteInfo.filter(site => site.displayName?.trim().toLowerCase() === this.currentDirectory?.siteDisplayName?.trim().toLowerCase());
                const documentLibraries: documentLibraryItem[] = sites.reduce((acc, current) => [...acc, ...current.documentLibraries], []);
                let documentLibrary: documentLibraryItem = documentLibraries.find(item => item.title?.trim().toLowerCase() === this.currentDirectory?.DocumentLibrary?.trim().toLowerCase());
                return this.documentLibraryIsViewable(documentLibrary);
            } catch (error) {
                logger(error, "folderView.ts (canViewFolder)");
            }
        }
        return true;
    };

    private documentLibraryIsViewable(documentLibrary: documentLibraryItem) {
        return documentLibrary?.autoFolderCreationEnabled ? false : true;
    }
}